import { Star, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV_LINKS, phoneTel } from "../../lib/constants";
import { useSettings } from "../../lib/SettingsContext";
import { scrollToId } from "../../lib/lenis";

export const Footer = () => {
  const s = useSettings();

  return (
  <footer data-testid="footer" className="border-t border-[#1c1c20] bg-[#08080a] pt-14 pb-24 md:pb-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <span className="w-9 h-9 rounded-lg bg-yellow-400 flex items-center justify-center rotate-3">
            <Star className="w-5 h-5 text-black" fill="currentColor" />
          </span>
          <span className="font-display font-bold text-xl text-white">
            بنشر متنقل <span className="text-yellow-400">نجم الإطارات</span>
          </span>
        </div>
        <p className="text-sm text-zinc-500 leading-relaxed">
          بنشر متنقل في الرياض — إطارات، بطاريات، وحساسات TPMS في موقعك، على مدار الساعة.
        </p>
      </div>
      <div>
        <div className="font-display font-bold text-white mb-4">روابط سريعة</div>
        <div className="grid grid-cols-2 gap-2">
          {NAV_LINKS.map((l) => (
            <button key={l.id} data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)} className="text-right text-sm text-zinc-500 hover:text-yellow-400 transition-colors">
              {l.label}
            </button>
          ))}
        </div>
      </div>
      <div>
        <div className="font-display font-bold text-white mb-4">تواصل معنا</div>
        <a data-testid="footer-phone-link" href={phoneTel(s.phone_display)} className="flex items-center gap-2 text-zinc-400 hover:text-yellow-400 transition-colors text-sm">
          <Phone className="w-4 h-4" />
          <span dir="ltr">{s.phone_display}</span>
        </a>
        <div className="text-sm text-zinc-500 mt-2">{s.location_text} — {s.hours}</div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-[#1c1c20] flex flex-wrap items-center justify-between gap-3 text-xs text-zinc-600">
      <span>© 2026 بنشر متنقل نجم الإطارات — جميع الحقوق محفوظة</span>
      <Link data-testid="footer-admin-link" to="/admin/login" className="hover:text-yellow-400 transition-colors">
        دخول الإدارة
      </Link>
    </div>
  </footer>
  );
};
